/* =============================================
   NIVMÉH — Theme JavaScript
   ============================================= */

/* ── Mobile Menu ── */
const menuBtn   = document.getElementById('menu-open');
const menuClose = document.getElementById('menu-close');
const mobileMenu = document.getElementById('mobile-menu');

if (menuBtn)   menuBtn.addEventListener('click',   () => mobileMenu.classList.add('open'));
if (menuClose) menuClose.addEventListener('click', () => mobileMenu.classList.remove('open'));

/* ── Search Overlay ── */
const searchBtns    = document.querySelectorAll('[data-search-open]');
const searchClose   = document.getElementById('search-close');
const searchOverlay = document.getElementById('search-overlay');
const searchInput   = document.getElementById('search-input');

searchBtns.forEach(btn => btn.addEventListener('click', () => {
  searchOverlay.classList.add('open');
  setTimeout(() => searchInput && searchInput.focus(), 100);
}));
if (searchClose) searchClose.addEventListener('click', () => searchOverlay.classList.remove('open'));
if (searchOverlay) searchOverlay.addEventListener('click', e => {
  if (e.target === searchOverlay) searchOverlay.classList.remove('open');
});
document.addEventListener('keydown', e => {
  if (e.key === 'Escape') {
    if (searchOverlay) searchOverlay.classList.remove('open');
    if (mobileMenu)   mobileMenu.classList.remove('open');
  }
});

/* ── Cart Drawer ── */
const cartOverlay = document.getElementById('cart-overlay');
const cartDrawer  = document.getElementById('cart-drawer');
const cartBtns    = document.querySelectorAll('[data-cart-open]');
const cartClose   = document.getElementById('cart-close');

function openCart() {
  if (cartDrawer)  cartDrawer.classList.add('open');
  if (cartOverlay) cartOverlay.classList.add('open');
}
function closeCart() {
  if (cartDrawer)  cartDrawer.classList.remove('open');
  if (cartOverlay) cartOverlay.classList.remove('open');
}
cartBtns.forEach(btn => btn.addEventListener('click', openCart));
if (cartClose)   cartClose.addEventListener('click', closeCart);
if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

/* ── Wishlist Drawer ── */
const wishlistDrawer  = document.getElementById('wishlist-drawer');
const wishlistOverlay = document.getElementById('wishlist-overlay');
const wishlistBtns    = document.querySelectorAll('[data-wishlist-open]');
const wishlistClose   = document.getElementById('wishlist-close');

function openWishlist() {
  if (wishlistDrawer)  wishlistDrawer.classList.add('open');
  if (wishlistOverlay) wishlistOverlay.classList.add('open');
}
function closeWishlist() {
  if (wishlistDrawer)  wishlistDrawer.classList.remove('open');
  if (wishlistOverlay) wishlistOverlay.classList.remove('open');
}
wishlistBtns.forEach(btn => btn.addEventListener('click', openWishlist));
if (wishlistClose)   wishlistClose.addEventListener('click', closeWishlist);
if (wishlistOverlay) wishlistOverlay.addEventListener('click', closeWishlist);

/* ── Product Image Gallery ── */
const thumbs    = document.querySelectorAll('.product-images__thumb');
const mainImage = document.getElementById('product-main-image');

thumbs.forEach(thumb => {
  thumb.addEventListener('click', () => {
    thumbs.forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');
    if (mainImage) {
      const src = thumb.querySelector('img').src;
      mainImage.src = src;
    }
  });
});

/* ── Product Variant Selection ── */
const variantBtns = document.querySelectorAll('.variant-btn');
variantBtns.forEach(btn => {
  btn.addEventListener('click', () => {
    const group = btn.closest('.variant-btns');
    if (group) group.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    const labelTarget = btn.dataset.variantGroup;
    const labelEl = document.querySelector(`[data-variant-label="${labelTarget}"]`);
    if (labelEl) labelEl.textContent = btn.dataset.variantValue || btn.textContent.trim();
  });
});

/* ── Quantity Selector ── */
document.querySelectorAll('.qty-selector').forEach(wrap => {
  const input = wrap.querySelector('.qty-selector__input');
  const minus = wrap.querySelector('[data-qty-minus]');
  const plus  = wrap.querySelector('[data-qty-plus]');
  if (!input) return;

  if (minus) minus.addEventListener('click', () => {
    const val = parseInt(input.value) || 1;
    if (val > 1) input.value = val - 1;
  });
  if (plus) plus.addEventListener('click', () => {
    input.value = (parseInt(input.value) || 1) + 1;
  });
});

/* ── Accordion ── */
document.querySelectorAll('.accordion-header').forEach(header => {
  header.addEventListener('click', () => {
    const body = header.nextElementSibling;
    const icon = header.querySelector('.material-symbols-outlined');
    const isOpen = body.classList.contains('open');

    document.querySelectorAll('.accordion-body').forEach(b => b.classList.remove('open'));
    document.querySelectorAll('.accordion-header .material-symbols-outlined').forEach(i => i.style.transform = '');

    if (!isOpen) {
      body.classList.add('open');
      if (icon) icon.style.transform = 'rotate(180deg)';
    }
  });
});

/* ── Add to Cart (AJAX) ── */
document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
  btn.addEventListener('click', async (e) => {
    e.preventDefault();
    const form = btn.closest('form[action="/cart/add"]') || btn.closest('[data-product-form]');
    if (!form) return;

    const variantId = form.querySelector('[name="id"]')?.value;
    const qty       = form.querySelector('[name="quantity"]')?.value || 1;
    if (!variantId) return;

    const originalText = btn.textContent;
    btn.textContent = 'Adding...';
    btn.disabled = true;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: parseInt(qty) })
      });
      const data = await res.json();
      if (data.id) {
        btn.textContent = 'Added!';
        updateCartCount();
        setTimeout(() => {
          btn.textContent = originalText;
          btn.disabled = false;
          openCart();
        }, 1200);
      } else {
        btn.textContent = 'Error';
        btn.disabled = false;
      }
    } catch {
      btn.textContent = originalText;
      btn.disabled = false;
    }
  });
});

/* ── Quick Add (Collection) ── */
document.querySelectorAll('[data-quick-add]').forEach(btn => {
  btn.addEventListener('click', async (e) => {
    e.preventDefault();
    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    const orig = btn.textContent;
    btn.textContent = 'Adding...';

    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      btn.textContent = 'Added to Bag';
      btn.style.backgroundColor = 'var(--c-surface-tint)';
      updateCartCount();
      setTimeout(() => {
        btn.textContent = orig;
        btn.style.backgroundColor = '';
      }, 2000);
    } catch {
      btn.textContent = orig;
    }
  });
});

/* ── Update Cart Count Badge ── */
async function updateCartCount() {
  try {
    const res  = await fetch('/cart.js');
    const cart = await res.json();
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });
  } catch {}
}

/* ── Pincode Check ── */
const pincodeBtn   = document.getElementById('check-pincode');
const pincodeInput = document.getElementById('pincode-input');
const pincodeResult= document.getElementById('pincode-result');

if (pincodeBtn && pincodeInput) {
  pincodeBtn.addEventListener('click', () => {
    const code = pincodeInput.value.trim();
    if (!code) return;
    if (pincodeResult) {
      pincodeResult.style.color  = 'var(--c-primary)';
      pincodeResult.textContent  = `✓ Delivery available to ${code} — arrives in 3–5 business days.`;
    }
  });
}

/* ── Newsletter Form ── */
document.querySelectorAll('[data-newsletter-form]').forEach(form => {
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const email = form.querySelector('input[type="email"]')?.value;
    const btn   = form.querySelector('button[type="submit"]') || form.querySelector('[data-submit]');
    if (!email || !btn) return;
    const orig = btn.textContent;
    btn.textContent = '✓ Subscribed!';
    btn.style.color = 'var(--c-primary)';
    setTimeout(() => { btn.textContent = orig; btn.style.color = ''; }, 3000);
  });
});

/* ── Contact Form Validation ── */
const contactForm = document.getElementById('contact-form');
if (contactForm) {
  contactForm.addEventListener('submit', (e) => {
    const required = contactForm.querySelectorAll('[required]');
    let valid = true;
    required.forEach(field => {
      if (!field.value.trim()) {
        valid = false;
        field.style.borderBottomColor = 'var(--c-error)';
      } else {
        field.style.borderBottomColor = '';
      }
    });
    if (!valid) { e.preventDefault(); }
  });
}

/* ── Bulk Inquiry Form Validation ── */
const bulkForm = document.getElementById('bulk-inquiry-form');
if (bulkForm) {
  bulkForm.addEventListener('submit', (e) => {
    const required = bulkForm.querySelectorAll('[required]');
    let valid = true;
    required.forEach(field => {
      if (!field.value.trim()) {
        valid = false;
        field.style.borderBottomColor = 'var(--c-error)';
      }
    });
    if (!valid) e.preventDefault();
  });
}

/* ── Cart Page Remove Item ── */
document.querySelectorAll('[data-remove-item]').forEach(btn => {
  btn.addEventListener('click', async () => {
    const key = btn.dataset.removeItem;
    if (!key) return;
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      });
      btn.closest('.cart-item')?.remove();
      updateCartCount();
      updateCartTotals();
    } catch {}
  });
});

async function updateCartTotals() {
  try {
    const res  = await fetch('/cart.js');
    const cart = await res.json();
    const totalEl = document.getElementById('cart-total');
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
  } catch {}
}

function formatMoney(cents) {
  return '₹' + (cents / 100).toFixed(2);
}

/* ── Gift Builder Step Navigation ── */
const builderSteps = document.querySelectorAll('[data-builder-step]');
const builderNextBtns = document.querySelectorAll('[data-next-step]');

function showStep(step) {
  builderSteps.forEach(s => {
    s.style.display = s.dataset.builderStep === step ? 'block' : 'none';
  });
}

builderNextBtns.forEach(btn => {
  btn.addEventListener('click', () => {
    const next = btn.dataset.nextStep;
    if (next) showStep(next);
  });
});

/* ── Sticky Header Shadow on Scroll ── */
window.addEventListener('scroll', () => {
  const header = document.getElementById('site-header');
  if (header) {
    header.style.boxShadow = window.scrollY > 40
      ? '0 4px 20px rgba(45,75,55,0.08)'
      : 'none';
  }
}, { passive: true });

/* ── Price Range Filter ── */
const rangeInput = document.getElementById('price-range');
const rangeMax   = document.getElementById('price-range-max');
if (rangeInput && rangeMax) {
  rangeInput.addEventListener('input', () => {
    rangeMax.textContent = '₹' + rangeInput.value;
  });
}

/* ── Smooth anchor scroll ── */
document.querySelectorAll('a[href^="#"]').forEach(a => {
  a.addEventListener('click', e => {
    const target = document.querySelector(a.getAttribute('href'));
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
});

/* ── Init ── */
updateCartCount();
